import React, { useState } from "react";
import { GiCancel } from "react-icons/gi";
import { FiSave } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({ rec, handleCancelClick, increment, counter, setRecId }) => {
  const [newRec, setNewRec] = useState(rec);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewRec((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "recommend/" + newRec.id + "/",
          newRec,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setRecId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          name="first_name"
          className="form-control"
          id="first_name"
          value={newRec.first_name}
          placeholder="תקליד שם פרטי"
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="last_name"
          className="form-control"
          id="last_name"
          value={newRec.last_name}
          placeholder="תקליד שם משפחה"
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="job"
          className="form-control"
          id="job"
          value={newRec.job}
          placeholder="התפקיד של הממליץ"
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="address"
          className="form-control"
          id="address"
          value={newRec.address}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="tel"
          className="form-control"
          id="tel"
          value={newRec.tel}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          <FiSave />
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          <GiCancel />
        </button>
      </td>
    </tr>
  );
};

export default Edit;
